export interface QuotedHeaderField {
  label: string;
  value: string;
}

/** Parse "From: foo" style lines into label/value pairs. */
export function parseQuotedHeaderMeta(lines: string[]): QuotedHeaderField[] {
  return lines
    .map((line) => {
      const colon = line.indexOf(':');
      if (colon <= 0) return { label: line.trim(), value: '' };
      return {
        label: line.slice(0, colon).trim(),
        value: line.slice(colon + 1).trim(),
      };
    })
    .filter((f) => f.label.length > 0);
}

export function quotedPanelHeading(
  headerLines: string[],
  mode: 'reply' | 'forward',
): string {
  return headerLines[0] ?? (mode === 'reply' ? 'Original message' : 'Forwarded message');
}

function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/** HTML header block for outbound forward/reply (email-client friendly table layout). */
export function quotedHeaderToOutboundHtml(headerLines: string[]): string {
  if (headerLines.length === 0) return '';

  const heading = escapeHtml(headerLines[0] ?? '');
  const fields = parseQuotedHeaderMeta(headerLines.slice(1));
  const isForward = heading.toLowerCase().includes('forward');

  const rows = fields
    .map(({ label, value }) => {
      const isSubject = label.toLowerCase() === 'subject';
      return `<tr>
        <td style="vertical-align:top;padding:3px 12px 3px 0;color:#64748b;font-size:12px;font-weight:600;white-space:nowrap;">${escapeHtml(label)}</td>
        <td style="vertical-align:top;padding:3px 0;color:#0f172a;font-size:13px;${isSubject ? 'font-weight:600;' : ''}word-break:break-word;">${escapeHtml(value)}</td>
      </tr>`;
    })
    .join('');

  const accent = isForward ? '#6366f1' : '#0ea5e9';
  const bg = isForward ? '#f5f3ff' : '#f0f9ff';
  const titleColor = isForward ? '#4338ca' : '#0369a1';

  return `<div class="email-quoted-meta-card" style="margin:0 0 12px;border:1px solid #e2e8f0;border-left:4px solid ${accent};border-radius:8px;background:${bg};overflow:hidden;font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,sans-serif;">
    <div style="padding:12px 14px 10px;border-bottom:1px solid #e2e8f0;background:rgba(255,255,255,0.65);">
      <span style="display:block;font-size:11px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:${titleColor};">${heading}</span>
    </div>
    <div style="padding:12px 14px 14px;">
      <table role="presentation" cellpadding="0" cellspacing="0" style="width:100%;border-collapse:collapse;margin:0;">
        <tbody>${rows}</tbody>
      </table>
    </div>
  </div>`;
}
